import { ColumnLabel } from "@components/Table/Settings/Toolbar";
import { createSuppliers, editSuppliers, getSuppliers, inactivateSuppliers } from "@services/form";
import { IClientResponse } from "@types";
import { useT } from "@hooks";
import SettingsCrudPage from "./SettingsCrudPage";
import SettingsNameDialogs from "./SettingsNameDialogs";
import useSettingsCrudPage from "./useSettingsCrudPage";

const defaultColumnOrder = ["name"];

interface Props {
  supplierType: string;
  translationPrefix: string;
}

const SupplierClientPage = ({ supplierType, translationPrefix }: Props) => {
  const t = useT();

  const crud = useSettingsCrudPage({
    translationPrefix,
    fetchService: () => getSuppliers(supplierType),
    mountOption: (data: IClientResponse[]) =>
      data?.map((res) => ({
        id: res.id,
        name: res.name,
        date: "",
        active: res?.active,
      })),
    createService: (value) => createSuppliers({ name: value, type: supplierType }),
    editService: (selected, value) => editSuppliers({ id: selected.id, name: value, type: supplierType }),
    inactivateService: inactivateSuppliers,
  });

  const columnLabels: ColumnLabel = {
    id: "1",
    name: t(`${translationPrefix}.column.name`),
    date: "",
  };

  return (
    <SettingsCrudPage
      crud={crud}
      translationPrefix={translationPrefix}
      columnLabels={columnLabels}
      defaultColumnOrder={defaultColumnOrder}
    >
      <SettingsNameDialogs
        crud={crud}
        newTitle={t(`${translationPrefix}.dialog.newTitle`)}
        editTitle={t(`${translationPrefix}.dialog.editTitle`)}
        newPlaceholder={t(`${translationPrefix}.placeholder.name`)}
        editPlaceholder={t(`${translationPrefix}.placeholder.name`)}
      />
    </SettingsCrudPage>
  );
};

export default SupplierClientPage;
